import { getConfigOf } from '@/services/formatter_services/enums/CURRENCY_TYPE_CONFIG';
import CURRENCY_SYMBOL_CHAR from '@/services/formatter_services/enums/CURRENCY_SYMBOL_CHAR'
import currency from 'currency.js';

const formatNumberToCurrency = (value, currencyType = "EUR", withCurrency = true, defaultCurrency = 0) => {
  if (isNaN(value)) {
    value = defaultCurrency;
  }
  const formatting = getConfigOf(currencyType);
  let format = {...formatting, symbol: CURRENCY_SYMBOL_CHAR[currencyType] ?? currencyType, };
  if(!withCurrency){
    format.pattern = '#';
  }
  return currency(value, format).format();
}

const formatCurrencyToNumber = (value = 0, currencyType = "EUR") => {
  const formatting = getConfigOf(currencyType);
  return currency(value, formatting).value
}

const getSymbol = (currencyType = "EUR") => {
  return CURRENCY_SYMBOL_CHAR[currencyType] ?? currencyType
}

const formatNumberToCurrencyWithEmpty = (value, currencyType = 'EUR') => formatNumberToCurrency(value, currencyType, true, '')
const presentNumberToCurrencyTable = (value = 0) => formatNumberToCurrency(value, 'EUR', true, '')

export { formatNumberToCurrency, formatCurrencyToNumber, formatNumberToCurrencyWithEmpty, presentNumberToCurrencyTable, getSymbol };

